<template>
    <v-layout justify-center>
        <v-responsive max-width="480" width="100%" class="px-3 mx-n3">
            <list-heading title="해시태그 설정" />

            <v-card outlined v-bind="{ loading }">
                <v-card-text >
                    <template v-if="setting">
                        <v-text-field v-model="text" label="신규항목" placeholder="키워드 작성 후 Enter를 눌러주세요" v-bind="attrs_input" append-icon="mdi-plus" @click:append="add" @keydown.enter="add" />
                        <v-chip-group column>
                            <draggable v-model="setting.hashTags" class="mb-n2">
                                <template v-for="(item, index) in setting.hashTags">
                                    <v-chip :key="item" outlined label close @click:close="setting.hashTags.splice(index, 1)"> {{ item }} </v-chip>
                                </template>
                            </draggable>
                        </v-chip-group>
                    </template>
                    <template v-else>
                        <v-skeleton-loader type="image" />
                    </template>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" v-bind="{ loading }" @click="save">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

import Draggable from "vuedraggable";
import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        Draggable,
        ListHeading,
    },
    data: () => ({
        setting: undefined,

        text: null,
        loading: false,
        attrs_input,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { setting } = await api.console.setting.get();
                this.setting = setting;
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const setting = JSON.parse(JSON.stringify(this.setting));
                await api.console.setting.put(setting);

                alert("저장되었습니다.");
            } finally {
                this.loading = false;
            }
        },

        add() {
            try {
                if (this.setting.hashTags.includes(this.text)) {
                    throw new Error("이미 추가된 항목입니다");
                }

                this.setting.hashTags.push(this.text);
                this.text = null;
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>
